import React, { useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import TranslationPage from './pages/TranslationPage';
import ChatbotPage from './pages/ChatbotPage';
import DictionaryPage from './pages/DictionaryPage';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';

type Page = 'translation' | 'chatbot' | 'dictionary' | 'login' | 'profile';

const AppContent: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<Page>('chatbot');
  const { isAuthenticated, user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    setCurrentPage('chatbot');
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Navigation Tabs */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between">
            <div className="flex space-x-1">
            <button
              onClick={() => setCurrentPage('chatbot')}
              className={`px-6 py-3 font-medium text-sm transition-colors ${
                currentPage === 'chatbot'
                  ? 'text-blue-600 border-b-2 border-blue-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              AI Assistant
            </button>
            <button
              onClick={() => setCurrentPage('translation')}
              className={`px-6 py-3 font-medium text-sm transition-colors ${
                currentPage === 'translation'
                  ? 'text-blue-600 border-b-2 border-blue-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Real-time Translation
            </button>
            <button
              onClick={() => setCurrentPage('dictionary')}
              className={`px-6 py-3 font-medium text-sm transition-colors ${
                currentPage === 'dictionary'
                  ? 'text-blue-600 border-b-2 border-blue-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Dictionary
            </button>
            </div>
            <div className="flex items-center space-x-4">
              {isAuthenticated ? (
                <>
                  <button
                    onClick={() => setCurrentPage('profile')}
                    className="px-4 py-2 text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors flex items-center gap-2"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    <span>{user?.name || user?.username}</span>
                  </button>
                  <button
                    onClick={handleLogout}
                    className="px-4 py-2 text-sm bg-gray-200 hover:bg-gray-300 rounded-lg transition-colors"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <button
                  onClick={() => setCurrentPage('login')}
                  className="px-4 py-2 text-sm bg-blue-500 text-white hover:bg-blue-600 rounded-lg transition-colors"
                >
                  Login
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Page Content */}
      {currentPage === 'translation' && <TranslationPage />}
      {currentPage === 'chatbot' && <ChatbotPage />}
      {currentPage === 'dictionary' && <DictionaryPage />}
      {currentPage === 'login' && <LoginPage onSuccess={() => setCurrentPage('chatbot')} />}
      {currentPage === 'profile' && <ProfilePage onSuccess={() => setCurrentPage('chatbot')} />}
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;



